import { API } from "../../apiSlice";

export const unlockAccountApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    unlockAccount: builder.mutation({
      query: (data) => {
        return {
          url: "users/unlock",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useUnlockAccountMutation } = unlockAccountApiSlice;
